<template>
  <ul class="list-group">
    <template v-if="isLoading">
      <li v-for="n in 5" :key="'skeleton-' + n" class="list-group-item placeholder-glow">
        <div class="row w-100">
          <div class="col-12 col-md-8">
            <div class="placeholder col-6 mb-2"></div>
            <div class="placeholder col-4"></div>
          </div>
          <div class="col-12 col-md-4 text-md-end text-start mt-2 mt-md-0">
            <div class="placeholder col-3 mb-2"></div>
            <div class="placeholder col-2"></div>
          </div>
        </div>
      </li>
    </template>

    <div v-else-if="!data || data.length === 0" class="text-center text-muted p-3">
      <i class="bi bi-database-x"></i> No data available
    </div>

    <template v-else>
      <li v-for="msg in data" :key="msg.id" class="list-group-item">
        <div class="row w-100">
          <div class="col-12 col-md-8">
            <div class="fw-semibold mb-1">{{ msg.message }}</div>
            <div class="meta-info">
              <span><i class="bi bi-hash"></i> {{ msg.id }}</span>
              <span><i class="bi bi-cpu"></i> Device: {{ msg.deviceId }} {{ msg.deviceName }}</span>
              <span><i class="bi bi-calendar-event"></i> {{ msg.date }}</span>
            </div>
          </div>

          <div class="col-12 col-md-4 text-md-end text-start mt-2 mt-md-0">
            <div :class="['badge status-badge mb-2', getBadgeClass(msg.type)]">
              <i :class="getIcon(msg.type)"></i> {{ msg.type }}
            </div>
            <div>
              <button class="btn btn-sm btn-outline-danger" @click="$emit('delete', msg)">
                <i class="bi bi-trash me-1"></i> Delete
              </button>
            </div>
          </div>
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  props: ["data", "isLoading"],
  methods: {
    getBadgeClass(type) {
      return type === "ERROR" ? "bg-danger" : "bg-info";
    },
    getIcon(type) {
      return type === "ERROR"
        ? "bi bi-exclamation-triangle-fill text-light"
        : "bi bi-check-circle-fill text-light";
    },
  },
};
</script>

<style scoped>
.list-group-item {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.meta-info {
  font-size: 0.85rem;
  color: #6c757d;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.status-badge {
  padding: 6px 10px;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: 12px;
  min-width: 80px;
  text-align: center;
}

.placeholder {
  display: inline-block;
  height: 1rem;
  background-color: #dee2e6 !important;
  border-radius: 4px;
}

.placeholder-glow .placeholder {
  animation: shimmer 1.5s infinite linear;
}

@keyframes shimmer {
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
}
</style>
